import React from "react";
import pizza from "../logos/pizza.png"

function Practice() {
	return (
		<div className="practice">
			<h1>Time for some practice babayyyyyyy</h1>
			<p>Currently under construction, so here is some hypnotizing pizza for Rico instead...</p>
			<img src={pizza} alt ="pizza" />
		</div>
	);
}

export default Practice;
